import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import keycloak from "./keycloak";
import vuetify from "./plugins/vuetify";
import { PublicClientApplication } from "@azure/msal-browser";

import '@/styles/login-page.css'
import '@/styles/dashboard-page.css'
import '@/styles/components.css'
import '@/styles/admin-panel.css'

const msalInstance = new PublicClientApplication({
  auth: {
    clientId: process.env.VUE_APP_MICROSOFT,
    authority: `https://login.microsoftonline.com/${process.env.VUE_APP_MICROSOFT_TENANT_ID}`,
    redirectUri: process.env.VUE_APP_URL,
    navigateToLoginRequestUrl: false
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false
  }
});

async function bootstrap() {
  await msalInstance.initialize();

  const msalResponse = await msalInstance.handleRedirectPromise();

  if (msalResponse?.account) {
    msalInstance.setActiveAccount(msalResponse.account);

    sessionStorage.setItem(
      "msal_response",
      JSON.stringify({
        account: msalResponse.account,
        idTokenClaims: msalResponse.idTokenClaims
      })
    );
  }

  try {
    await keycloak.init({
      onLoad: 'check-sso',
      pkceMethod: 'S256',
      checkLoginIframe: false
    });
  } catch (error) {
    console.error('Erro ao inicializar Keycloak:', error);
  }

  const app = createApp(App);

  app.config.globalProperties.$keycloak = keycloak;
  app.config.globalProperties.$msal = msalInstance;

  app.use(router);
  app.use(vuetify);
  app.mount("#app");
}

bootstrap();